import { includes } from 'lodash';

export const classNameForGA = (url) => (url?.indexOf('http') > -1 && !includes(url, 'whisper.jp') ? 'event_outbound_link' : 'event_internal_link');
export const dataActionForGA = (url) => ({ 'data-action-detail': url });
